<template>
  <div style="float:'right'">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="curIndex"
      :page-sizes="[10, 20, 30]"
      :page-size="pageSize"
      small
      :pager-count="5"
      layout="total,sizes, prev, pager, next, jumper"
      :total="count"
    ></el-pagination>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  props: {
    url: '',
    form: {},
    flag: {},
    rightSearch: {
      type: Boolean,
      default: true
    },
    urlDafault: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      curIndex: 1,
      pageSize: 10,
      count: 0
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.curIndex = val
      this.getTableData()
    },
    getTableData (refresh) {
      let user = JSON.parse(localStorage.getItem('user'))
      let param = {
        data: this.form,
        pageIndex: this.curIndex - 1,
        pageSize: this.pageSize,
        asp: user.asp
      }
      if (refresh == 'true') {
        param = { data: {}, pageIndex: 0, pageSize: this.pageSize }
      }
      if (refresh == 'refresh') {
        param = { data: this.form, pageIndex: 0, pageSize: this.pageSize, asp: user.asp }
      }
      if (refresh == 'CKTZ') {
        param = {
          data: this.form,
          pageIndex: 0,
          pageSize: this.pageSize,
          asp: user.asp,
          data: { typeCode: 'CKTZ' }
        }
      }
      let flag =
        (this.$route.name === 'MeetingReq' || this.$route.name === 'IJoinMeeting') && !this.urlDafault
      this.$axios
        .post(flag ? this.global.MSI_OA + '/meeting/findOaMeetingManagPage' : this.url, param)
        .then(res => {
          if (res.data.code === '0000') {
            this.pageSize = res.data.pageSize
            this.curIndex = res.data.curIndex + 1
            this.count = res.data.count
            this.$emit('page-change', res.data)
          }
        })
    }
  },
  created () {
    if (!this.flag && this.rightSearch) {
      this.getTableData()
    }
  }
}
</script>

<style scoped>
::v-deep .el-pagination__editor {
  width:60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TablePage.vue